import { render } from "./UserInfoSectionSeikyuTantoCmp.vue?vue&type=template&id=60ed0c3e&scoped=true"
import script from "./UserInfoSectionSeikyuTantoCmp.vue?vue&type=script&lang=js"
export * from "./UserInfoSectionSeikyuTantoCmp.vue?vue&type=script&lang=js"

import "../css/UserInfoSectionSeikyuTanto.css?vue&type=style&index=0&id=60ed0c3e&scoped=true&lang=css"
import "./UserInfoSectionSeikyuTantoCmp.vue?vue&type=style&index=1&id=60ed0c3e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src426064190/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ed0c3e"]])

export default __exports__